export function isMobile(): boolean {
    return /Android|iPhone|iPad|iPod/.test(navigator.userAgent);
}

export function isIOS(): boolean {
    return /iPad|iPhone|iPod/.test(navigator.userAgent);
}

export function isStandalone(): boolean {
    return (
        ('standalone' in navigator && (navigator as any).standalone) ||
        window.matchMedia('(display-mode: standalone)').matches
    );
}
